import React, { useRef } from "react";
import { FormProvider } from "react-hook-form";
import { Button } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Edit } from "@refinedev/mui";
import { useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import {
  AgreementForm,
  CloneAgreementModal,
} from "@modules/agreements/components";
import { useAgreementEditForm } from "./controller";

export const AgreementEdit = React.memo(() => {
  const translate = useTranslate();
  const cloneModalRef = useRef<ModalRef>(null);
  const { methods, handleSubmit, isPending, formLoading, id } =
    useAgreementEditForm();

  const sourceName = methods.watch("name");

  return (
    <>
      <Edit
        recordItemId={id}
        saveButtonProps={{
          onClick: handleSubmit(),
          loading: isPending,
        }}
        isLoading={formLoading}
        headerButtons={({ defaultButtons }) => (
          <>
            <Button
              color="primary"
              startIcon={<ContentCopyIcon />}
              onClick={() => cloneModalRef.current?.open()}
              disabled={!id || formLoading}
              sx={{ minWidth: 0 }}
            >
              {translate("v1/agreement_admin.buttons.clone")}
            </Button>
            {defaultButtons}
          </>
        )}
      >
        <FormProvider {...methods}>
          <AgreementForm />
        </FormProvider>
      </Edit>

      {id && (
        <CloneAgreementModal
          modalRef={cloneModalRef}
          agreementId={id}
          sourceName={sourceName}
        />
      )}
    </>
  );
});
